export default __webpack_public_path__ + "static/media/IMG-20240822-WA0006.e65ae68f.jpg";